import { useRouter } from 'next/router';
import * as React from 'react';

export const useHistoryRouter = (trackHistory = true) => {
  const router = useRouter();
  const [history, setHistory] = React.useState<History>();

  React.useEffect(() => {
    setHistory(window.history);
  }, []);

  const goBack = React.useCallback(
    (defaultBack?: string) => {
      let lastAppUrls = [];
      try {
        lastAppUrls = JSON.parse(sessionStorage.getItem('lastUrl')) || [];
        // eslint-disable-next-line no-empty
      } catch (ex) {}
      if (lastAppUrls?.length === 2 && trackHistory) {
        const urlToReplace = lastAppUrls.shift();
        if (urlToReplace === router.asPath) {
          sessionStorage.setItem('lastUrl', '[]');
          router.replace(defaultBack || '/');
          return;
        }
        sessionStorage.setItem('lastUrl', JSON.stringify(lastAppUrls));
        router.replace(urlToReplace);
        return;
      }
      if (history?.length > 1) {
        router.back();
        return;
      }
      router.replace(defaultBack || '/');
    },
    [router, trackHistory, history?.length]
  );

  return {
    history,
    goBack,
  };
};
